import React from 'react';
import { Link } from 'react-router-dom';

export default function IsolationPage() {
  return (
    <>
      {/* Hero */}
      <section className="page-hero" style={{ background: "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url('/assets/images/ISOLATION.jpg') center/cover" }}>
        <div className="container" style={{ width: '100%' }}>
          <div className="hero-content">
            <h1 className="hero-title">Isolation <span className="text-accent">Thermique</span></h1>
            <p className="hero-subtitle">Améliorez le confort thermique de votre maison et réduisez vos déperditions énergétiques. Une isolation performante peut vous faire économiser <strong>jusqu'à 60%</strong> sur vos factures de chauffage.</p>
            <div className="hero-buttons" style={{ justifyContent: 'center', maxWidth: '400px', margin: '0 auto' }}>
              <Link to="/#contact" className="btn btn-primary" style={{ padding: '14px 28px', fontSize: '1rem' }}>Demander un devis gratuit</Link>
              <a href="tel:0465845177" className="phone-number" style={{ color: 'white', borderColor: 'white' }}>04 65 84 51 77</a>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="advantages-section">
        <div className="container">
          <div className="section-header">
            <h2>Pourquoi bien <span className="text-accent">isoler</span> ?</h2>
            <p>L'isolation est la première étape de la rénovation énergétique pour un confort optimal</p>
          </div>
          <div className="advantages-grid">
            {[
              { title: "Jusqu'à 60% d'économies", text: "Réduisez drastiquement vos factures de chauffage en limitant les déperditions thermiques de votre habitation." },
              { title: 'Confort thermique optimal', text: "Température homogène dans toutes les pièces, suppression des courants d'air et des parois froides." },
              { title: 'Valorisation immobilière', text: "Améliorez la classe énergétique de votre logement et augmentez sa valeur sur le marché immobilier." },
              { title: 'Confort acoustique', text: "Réduction significative des nuisances sonores extérieures pour un environnement plus paisible." },
            ].map((a) => (
              <div className="advantage-card" key={a.title}>
                <div className="advantage-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor"><path d="M10 2L3 7v2h18V7L14 2h-4zm-2 9v6H5v-6H3v9h18v-9h-2v6h-3v-6h-3v6h-2v-6H8z"/></svg>
                </div>
                <h3>{a.title}</h3>
                <p>{a.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="products-section">
        <div className="container">
          <div className="section-header">
            <h2>Nos solutions <span className="text-accent">d'isolation</span></h2>
            <p>Des solutions adaptées à tous types de projets et de budgets</p>
          </div>
          <div className="products-grid">
            {[
              {
                img: '/assets/images/Fotolia_139801946_L.jpg',
                title: 'Isolation Extérieure (ITE)',
                desc: "La solution la plus performante pour supprimer les ponts thermiques et améliorer l'esthétique de votre façade.",
                specs: [{ v: '60%', l: 'Économies' }, { v: 'A', l: 'Classe DPE' }, { v: '0 pont', l: 'Thermique' }, { v: '25 ans', l: 'Durée vie' }],
                featured: true,
              },
              {
                img: '/assets/images/Fotolia_81463074_L.jpg',
                title: 'Isolation des Combles',
                desc: "30% des déperditions de chaleur se font par le toit. L'isolation des combles est le geste le plus rentable.",
                specs: [{ v: '30%', l: 'Pertes' }, { v: '40%', l: 'Économies' }, { v: '1 jour', l: 'Travaux' }, { v: '25 ans', l: 'Durée vie' }],
              },
              {
                img: '/assets/images/Isolation_cave_0.png',
                title: 'Isolation des Murs Intérieurs',
                desc: "Solution idéale pour isoler votre logement de l'intérieur sans modifier l'aspect extérieur.",
                specs: [{ v: '25%', l: 'Économies' }, { v: 'B', l: 'Classe DPE' }, { v: 'Discret', l: 'Intérieur' }, { v: '25 ans', l: 'Durée vie' }],
              },
            ].map((p) => (
              <div className={`product-card ${p.featured ? 'featured' : ''}`} key={p.title}>
                {p.featured && <div className="product-badge">Recommandé</div>}
                <div className="product-image"><img src={p.img} alt={p.title} /></div>
                <div className="product-content">
                  <h3>{p.title}</h3>
                  <p className="product-description">{p.desc}</p>
                  <div className="product-specs-grid">
                    {p.specs.map((s) => (<div className="spec-item" key={s.l}><div className="spec-value">{s.v}</div><div className="spec-label">{s.l}</div></div>))}
                  </div>
                  <Link to="/#contact" className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>Demander un devis</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="installation-process">
        <div className="container">
          <div className="section-header">
            <h2>Notre processus <span className="text-accent">d'isolation</span></h2>
          </div>
          <div className="process-steps">
            {[
              { n: 1, title: 'Diagnostic thermique', text: "Analyse de votre logement par thermographie pour identifier les zones de déperditions." },
              { n: 2, title: 'Choix des matériaux', text: "Sélection des meilleurs isolants selon votre type de construction et vos objectifs." },
              { n: 3, title: 'Pose professionnelle', text: "Intervention de nos artisans certifiés RGE dans les délais convenus." },
              { n: 4, title: 'Contrôle qualité', text: "Vérification de l'absence de ponts thermiques et mesure de la résistance thermique obtenue." },
            ].map((s) => (
              <div className="process-step" key={s.n}>
                <div className="step-number">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Améliorez le confort de votre maison</h2>
          <p>Bénéficiez d'aides jusqu'à 90% du coût des travaux d'isolation</p>
          <div className="cta-buttons">
            <Link to="/#contact" className="btn btn-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Demander mon devis gratuit</Link>
            <a href="tel:0465845177" className="btn-outline-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Appeler le 04 65 84 51 77</a>
          </div>
        </div>
      </section>
    </>
  );
}
